import { Col, Row, Tooltip } from 'antd'
import React, { useEffect } from 'react'
import { RadioBtn } from '@edulastic/common'
import { connect } from 'react-redux'
import { roleuser } from '@edulastic/constants'
import { IconInfo } from '@edulastic/icons'
import { Label, StyledRadioGroupWrapper } from '../SimpleOptions/styled'
import { getUserRole } from '../../../src/selectors/user'

export const dynamicPasswordScopeInputFormat = {
  COLUMN_AND_ROWS: 'columnAndRows',
  COLUMN_AND_ROWS_EQUAL: 'columnAndRowsEqual',
  SINGLE_ROW: 'singleRow',
}

const DynamicPasswordScopeInput = ({
  role,
  disabled,
  disableUserLevel,
  value = 'class',
  onChange,
  visibilityFormat,
  preventOverride,
}) => {
  useEffect(() => {
    if (
      !roleuser.DA_SA_ROLE_ARRAY.includes(role) &&
      value === 'user' &&
      !preventOverride
    ) {
      onChange({
        target: { value: 'class' },
      })
    }
  }, [role, value, preventOverride])

  useEffect(() => {
    if (disableUserLevel && value === 'user') {
      onChange({
        target: { value: 'class' },
      })
    }
  }, [value, disableUserLevel])

  if (!roleuser.DA_SA_ROLE_ARRAY.includes(role)) {
    return null
  }

  const toolTip = disabled
    ? 'This setting was configured at the test level and cannot be changed from here'
    : disableUserLevel
    ? 'To enable test-level dynamic password, please edit the test from the Test Editor. This will apply to all active assignments for this test.'
    : ''

  const classOptionTooltip = (
    <Tooltip
      title={
        toolTip ||
        'Each class gets its own password, which auto-refreshes separately as per expiry interval. Offers better security and class-level control.'
      }
    >
      <IconInfo style={{ marginBottom: '-0.125rem', marginLeft: '0.25rem' }} />
    </Tooltip>
  )

  const userOptionTooltip = (
    <Tooltip
      title={
        toolTip ||
        'Each person who opens the test gets their own password, shared across the classes they opened it for. The password auto-refreshes separately as per expiry interval. Best for admins or teachers managing multiple classes.'
      }
    >
      <IconInfo style={{ marginBottom: '-0.125rem', marginLeft: '0.25rem' }} />
    </Tooltip>
  )

  switch (visibilityFormat) {
    case dynamicPasswordScopeInputFormat.COLUMN_AND_ROWS:
    case dynamicPasswordScopeInputFormat.COLUMN_AND_ROWS_EQUAL:
      return (
        <Col span={24}>
          <Row data-cy="dynamicPasswordScopeInputContainer">
            <Col
              span={
                visibilityFormat ===
                dynamicPasswordScopeInputFormat.COLUMN_AND_ROWS_EQUAL
                  ? 12
                  : 10
              }
            >
              <Label style={{ marginTop: '1rem' }}>
                DYNAMIC PASSWORD SCOPE
              </Label>
            </Col>
            <Col
              span={
                visibilityFormat ===
                dynamicPasswordScopeInputFormat.COLUMN_AND_ROWS_EQUAL
                  ? 12
                  : 14
              }
            >
              <StyledRadioGroupWrapper
                value={value}
                onChange={onChange}
                disabled={disabled}
                data-cy="dynamicPasswordScopeInput"
              >
                <RadioBtn
                  value="class"
                  data-cy="dynamicPasswordScopeClassRadioBtn"
                >
                  Generate unique password per class
                  {classOptionTooltip}
                </RadioBtn>
                <RadioBtn
                  value="user"
                  disabled={disableUserLevel}
                  data-cy="dynamicPasswordScopeUserRadioBtn"
                >
                  Generate unique password per Test Opener
                  {userOptionTooltip}
                </RadioBtn>
              </StyledRadioGroupWrapper>
            </Col>
          </Row>
        </Col>
      )
    case dynamicPasswordScopeInputFormat.SINGLE_ROW:
      return (
        <Col span={24}>
          <Row
            style={{
              display: 'flex',
              alignItems: 'baseline',
            }}
            data-cy="dynamicPasswordScopeInputContainer"
          >
            <Label
              style={{
                marginRight: '1rem',
              }}
            >
              Dynamic Password Scope
            </Label>
            <StyledRadioGroupWrapper
              value={value}
              onChange={onChange}
              disabled={disabled}
              data-cy="dynamicPasswordScopeInput"
            >
              <RadioBtn
                value="class"
                data-cy="dynamicPasswordScopeClassRadioBtn"
              >
                Generate unique password per class
                {classOptionTooltip}
              </RadioBtn>
              <RadioBtn
                value="user"
                disabled={disableUserLevel}
                data-cy="dynamicPasswordScopeUserRadioBtn"
              >
                Generate unique password per Test Opener
                {userOptionTooltip}
              </RadioBtn>
            </StyledRadioGroupWrapper>
          </Row>
        </Col>
      )
    default:
      return null
  }
}

const enhance = connect((state) => ({
  role: getUserRole(state),
}))

export default enhance(DynamicPasswordScopeInput)
